import React, { FC } from 'react';
import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';

import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';

import { ParkingPageId } from '../../../domain/pages/ParkingPageId';
import { AvailabilityResults } from '../../booking-steps/availability';
import { ParkingSearch } from '../../search';
import { useStartTimeMinimumOffsetInSeconds } from '../../search/helpers/useStartTimeMinimumOffsetInSeconds';
import { BookingPageLayout } from '../shared/BookingPageLayout';

export const NewBookingAvailabilityPage: FC = () => {
	const { t } = useTranslation();
	const parentUrl = useUrlForPageId(PassengersPageId.Parking);
	const extrasUrl = useUrlForPageId(ParkingPageId.NewBookingExtras);
	const detailsUrl = useUrlForPageId(ParkingPageId.NewBookingDetails);
	const startTimeMinimumOffsetInSeconds = useStartTimeMinimumOffsetInSeconds();

	return (
		<BookingPageLayout
			parentUrl={parentUrl}
			parentTitle={t('web_parking_availability_results_back_button')}
			title={t('web_parking_availability_results_header')}
		>
			<ParkingSearch
				title={t('parking_options_parking_availability_title')}
				shouldStayOnPage
				startTimeMinimumOffsetInSeconds={startTimeMinimumOffsetInSeconds}
			/>

			<AvailabilityResults
				previousUrl={parentUrl}
				extrasUrl={extrasUrl}
				fallbackUrl={detailsUrl}
			/>
		</BookingPageLayout>
	);
};
